module.exports = fox._r("images/valentines/gift-19.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines/gift-19.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines/gift-19.png
// module id = 243
// module chunks = 4